import { render, staticRenderFns } from "./IconBrowse.vue?vue&type=template&id=9c628238&"
import script from "./IconBrowse.vue?vue&type=script&lang=js&"
export * from "./IconBrowse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports